const styles = `:host {
  display: inline-flex;
  align-items: center;
  /* Using !important here is necessary. The most common reason is for MUI to add
    * { box-sizing: content-box; }
    and that will override any
    :host { box-sizing: border-box }
    in our code
  */
  box-sizing: border-box !important;
  max-width: 100%;
}
:host .icon {
  --goto-icon-size: 50px;
  position: relative;
}
:host .icon chameleon-icon-badge {
  display: grid;
  place-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
:host [name=image] {
  border-radius: 4px;
  display: inline-flex;
  height: 32px;
  margin-right: 0.75rem;
  width: 32px;
}
:host ::slotted(img) {
  border-radius: 4px;
  height: 100%;
  object-fit: cover;
  width: 100%;
}
:host .content {
  max-width: calc(100% - 50px);
}

:host([size=small]) .icon {
  --goto-icon-size: 38px;
}
:host([size=small]) .icon chameleon-icon-badge {
  background: none;
}
:host([size=small]) [name=image] {
  height: 24px;
  width: 24px;
}
:host([size=small]) .content {
  max-width: calc(100% - 40px);
}

:host([size=large]) {
  flex-direction: column;
  text-align: center;
}
:host([size=large]) .icon {
  --goto-icon-size: 125px;
}
:host([size=large]) [name=image] {
  height: 100px;
  margin-bottom: 0.75rem;
  margin-right: 0;
  width: 100px;
}
:host([size=large]) .content {
  max-width: 100%;
}`; export default styles;